import SelfieForm from "@/components/forms/Identity/SelfieForm.vue";
import CcSelfieForm from "@/components/forms/Identity/CcSelfieForm.vue";
import IdentityConfirmationForm from "@/components/forms/Identity/IdentityConfirmationForm.vue";
import IdentificationUploadForm from "@/components/forms/Identity/IdentificationUploadForm.vue";
import PurposeOfTransactionForm from "@/components/forms/Identity/PurposeOfTransactionForm.vue";
import SourceOfFundsForm from "@/components/forms/Identity/SourceOfFundsForm.vue";
import PepSourceOfFundsForm from "@/components/forms/Identity/PepSourceOfFundsForm.vue";
import PepSofDocumentUploadForm from "@/components/forms/Identity/PepSofDocumentUploadForm.vue";
import ProofOfAddressForm from "@/components/forms/Identity/ProofOfAddressForm.vue";
import SumsubForm from "@/components/forms/Identity/SumsubForm.vue";
import SofDocumentUploadForm from "@/components/forms/Identity/SofDocumentUploadForm.vue";
import OccupationForm from "@/components/forms/Identity/OccupationForm.vue";
import USTaxIDForm from "@/components/forms/Identity/USTaxIDForm.vue";
import DlocalIdentityForm from "@/components/forms/Identity/DlocalIdentityForm.vue";
import useProgressBarActions from "@/composables/progress/useProgressBarActions";
import DocumentNumberForm from "@/components/forms/Identity/DocumentNumberForm.vue";
import UpdateDetailForm from "@/components/forms/Identity/UpdateDetailForm.vue";
import ConfirmDetailForm from "@/components/forms/Identity/ConfirmDetailForm.vue";

const { updateToComplete } = useProgressBarActions();

const routes = [
  {
    path: "/identity/idUpload/:id",
    name: "identity.upload",
    component: IdentificationUploadForm,
    beforeEnter() {
      updateToComplete(["verification"]);
    },
  },
  {
    path: "/identity/identityConfirmation",
    name: "identity.identityConfirmation",
    component: IdentityConfirmationForm,
    beforeEnter() {
      updateToComplete(["verification"]);
    },
  },
  {
    path: "/identity/selfie",
    name: "identity.selfie",
    component: SelfieForm,
    beforeEnter() {
      updateToComplete(["verification"]);
    },
  },
  {
    path: "/identity/cc_selfie",
    name: "identity.cc.selfie",
    component: CcSelfieForm,
  },
  {
    path: "/identity/purposeOfTransaction",
    name: "identity.purposeOfTransaction",
    component: PurposeOfTransactionForm,
    beforeEnter() {
      updateToComplete(["verification"]);
    },
  },
  {
    path: "/identity/sourceOfFunds",
    name: "identity.sourceOfFunds",
    component: SourceOfFundsForm,
    beforeEnter() {
      updateToComplete(["verification"]);
    },
  },
  {
    path: "/identity/pepSourceOfFunds",
    name: "identity.pepSourceOfFunds",
    component: PepSourceOfFundsForm,
    beforeEnter() {
      updateToComplete(["verification"]);
    },
  },
  {
    path: "/identity/pepSofDocumentUpload",
    name: "identity.pepSourceOfFundsDocumentUpload",
    component: PepSofDocumentUploadForm,
    beforeEnter() {
      updateToComplete(["verification"]);
    },
  },
  {
    path: "/identity/sofDocumentUpload",
    name: "identity.sofDocumentUpload",
    component: SofDocumentUploadForm,
    beforeEnter() {
      updateToComplete(["verification"]);
    },
  },
  {
    path: "/identity/proofOfAddress",
    name: "identity.proofOfAddress",
    component: ProofOfAddressForm,
    beforeEnter() {
      updateToComplete(["verification"]);
    },
  },
  {
    path: "/identity/occupation",
    name: "identity.occupation",
    component: OccupationForm,
    beforeEnter() {
      updateToComplete(["verification"]);
    },
  },
  {
    path: "/identity/sumsub",
    name: "identity.sumsub",
    component: SumsubForm,
    beforeEnter() {
      updateToComplete(["verification"]);
    },
  },
  {
    path: "/identity/ssn",
    name: "identity.ssn",
    component: USTaxIDForm,
    beforeEnter() {
      updateToComplete(["verification"]);
    },
  },
  {
    path: "/identity/dlocal/:type",
    name: "identity.dlocal",
    component: DlocalIdentityForm,
    beforeEnter() {
      updateToComplete(["verification"]);
    },
  },
  {
    path: "/identity/documentNumber",
    name: "identity.documentNumber",
    component: DocumentNumberForm,
    beforeEnter() {
      updateToComplete(["verification"]);
    },
  },
  {
    path: "/identity/confirm-details",
    name: "identity.confirm-details",
    component: ConfirmDetailForm,
  },
  {
    path: "/identity/update-details",
    name: "identity.update-details",
    component: UpdateDetailForm,
  },
];

export default routes;
